import { Tour } from '../types';
import { welcomeTour } from './welcomeTour';
import { browseIntroTour, journeyIntroTour, journeyTodayIntroTour, journeyTrackerIntroTour, essaysIntroTour } from './pageTours';

/** Central tour registry — add new tours here */
export const tourRegistry: Record<string, Tour> = {
  [welcomeTour.id]: welcomeTour,
  [browseIntroTour.id]: browseIntroTour,
  [journeyTodayIntroTour.id]: journeyTodayIntroTour,
  [journeyTrackerIntroTour.id]: journeyTrackerIntroTour,
  // Legacy alias — journeyIntroTour has same id as journeyTrackerIntroTour
  [journeyIntroTour.id]: journeyIntroTour,
  [essaysIntroTour.id]: essaysIntroTour,
};

export { welcomeTour, browseIntroTour, journeyIntroTour, journeyTodayIntroTour, journeyTrackerIntroTour, essaysIntroTour };
